import React from 'react'
import { ReactElement } from "react"

export const Reporting = (): ReactElement => {
  window.location.href = `${process.env.NX_REPORTING_SSO_URL}`

  return <></>
}
